import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/81.png'


const _withScopeId = n => (_pushScopeId("data-v-9d30a0e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "call__btn" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "call"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "call__phones-wrapper"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_6 = { class: "call__phones" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "call__icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVisible && _ctx.toggleVisible(...args)))
    }, _hoisted_3),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "call__phone",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePop && _ctx.closePop(...args))),
              href: "tel:+79037983712"
            }, "+7 (903) 798-37-12"),
            _createElementVNode("a", {
              class: "call__phone",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePop && _ctx.closePop(...args))),
              href: "tel:+74957773089"
            }, "+7 (495) 777-30-89")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "big-bg",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closePop && _ctx.closePop(...args)))
        }))
      : _createCommentVNode("", true)
  ]))
}